module.exports = function(app) {
	'use strict';

	app.directive('eprInsurance', function() {
		return {
			template: require('directives/employee/eprInsurance.html'),
			restrict: 'A',
			replace: false,

			scope: {
				editMode: '=?',
				participant: '=eprInsurance'
			},

			controller: ['$scope', 'modal','addFlowCommander', 'options', 'employee',
				function ($scope, modal, addFlowCommander, options, employee) {

					$scope.commander = addFlowCommander;
					$scope.options = options;
					$scope.today = new Date();


                    $scope.todayPlus1 = new Date();
                    $scope.todayPlus1.setDate($scope.todayPlus1.getDate()+1);

                    $scope.dt1000 = new Date(1000, 1, 1);
                    $scope.dt1900 = new Date(1900, 1, 1);
                    $scope.dt9999 = new Date(9999, 1, 1);


                    //relation.optValue as relation.name for relation in options.custodyTypes
                    $scope.medResponsibilityCodeToName = function(strRelCode) {
                        // relationship.value as relationship.label for relationship in relationships
                        var strRetval = ''
                        angular.forEach($scope.options.custodyTypes, function(rel){
                            if (rel.optValue == strRelCode) {
                                strRetval = rel.name;
                            }
                        })

                        return strRetval;
                    };

                    $scope.custodyCodeToName = function(strRelCode) {
                        // relationship.value as relationship.label for relationship in relationships
                        var strRetval = ''
                        angular.forEach($scope.options.custodyTypes, function(rel){
                            if (rel.optValue == strRelCode) {
                                strRetval = rel.name;
                            }
                        })

                        return strRetval;
                    };


					var participantsWithOtherInsurance = employee.getParticipantsWithOtherInsurance(employee.data);
					$scope.showCopyToOthers = $scope.editMode && (participantsWithOtherInsurance.length > 1);

					if ($scope.showCopyToOthers) {
						$scope.copyToOthers = function() {

							var copyToOthers = function(s, others, scope) {
								scope = scope || $scope;

								var selectedOthers = others.filter(function(o) { return o.isChecked; });

								scope.selectionNeeded = false;
								if (others.length > 1) {
									scope.selectionNeeded = selectedOthers.length < 1;
									if (scope.selectionNeeded) { return false; }
								}

								selectedOthers.forEach(function(o) {
									for (var k in s.otherInsurance) {
										if (s.otherInsurance.hasOwnProperty(k)) {
											if (!(
													k === 'custody' &&
													s.otherInsurance.relationSubscriber == '3' &&
													(s.relationshipCode === '18' || s.relationshipCode === '01')
											)) {
												o.otherInsurance[k] = angular.copy(s.otherInsurance[k]);
											}
										}
									}
								});
								others.forEach(function(o) { delete o.isChecked; });
								return true;
							};

							var others = participantsWithOtherInsurance.slice(0);
							others.splice(others.indexOf($scope.participant), 1);

							if (others.length > 1) {
								var modalScope = $scope.$new();
								modalScope.selected = $scope.participant;
								modalScope.others = others;

								modalScope.modalHeading =
									'Copy Other Insurance Info from ' +
									[
										modalScope.selected.fullName.first,
										modalScope.selected.fullName.middle,
										modalScope.selected.fullName.last
									]
									.filter(function(n) { return n; }).join(' ');

								modalScope.copyToOthers = function() {
									copyToOthers(modalScope.selected, modalScope.others, modalScope) && modalScope.closeModal();
								};
								modalScope.selectAll = function() {
									others.forEach(function(o) { o.isChecked = true; });
								};
								modalScope.nothingSelected = function(others) {
									return !others.some(function(o) { return o.isChecked; });
								};
								modal.open({
									template: require('pages/employee/modals/copyToOthers.html'),
									scope: modalScope,
									classes: 'epr-standard-modal large-modal'
								});
							}
							else {
								others[0].isChecked = true;
								copyToOthers($scope.participant, others);
							}
						};
					}
				}
			]
		};
	});
};
